// extracted by mini-css-extract-plugin
export default {"dots":"DotLoader_dots__eFXM7","dots-7ar3yq":"DotLoader_dots-7ar3yq__BM8Nj"};